import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_11: FaireProductEntity = {
  token: "starter_collection_11",
  type: "product",
  name: "Blossom Puzzle",
  brandName: "Piecework",
  imageUrl: "",
  priceDollars: 36,
  msrpDollars: 72,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
